import { MenuList as GCDKMenuList } from "@graffer-inc/console-design-kit";
import { NavLink, useRouteMatch } from "react-router-dom";
import { FeatureTitles } from "../../../application/domain/faeture-titles";
import { useAuthContextV2 } from "../../../auth-state";
import { useRBAC } from "../../helpers/rbac/use-rbac";
import { SettingR } from "../../pages/settings/route";
import { StaticFeatureFlags } from "../../../feature-flags";

export const SettingsMenuList = () => {
  const hasPermission = useRBAC();
  const { auth } = useAuthContextV2();
  const { path } = useRouteMatch();

  return (
    <GCDKMenuList
      items={[
        {
          header: "グループ管理",
          navItems: [
            {
              title: "グループ一覧",
              hidden: !hasPermission({
                requirePermissions: "groups.create",
              }),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.Groups.link({})} />
              ),
              active: path === SettingR.Groups.link({}),
            },
          ],
        },
        {
          header: "アカウント管理",
          navItems: [
            {
              title: "ユーザー一覧",
              hidden: !hasPermission({
                requirePermissions: "users.create",
              }),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.Users.link({})} />
              ),
              active: path === SettingR.Users.link({}),
            },
            {
              title: "サービスアカウント",
              hidden: !hasPermission({
                requirePermissions: "service_account.service_account.read",
              }),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.ServiceAccounts.link({})} />
              ),
              active: path.startsWith(SettingR.ServiceAccounts.link({})),
            },
          ],
        },
        {
          header: "個人設定",
          navItems: [
            {
              title: "アカウント",
              hidden: false,
              anchor: (props) => (
                <NavLink {...props} to={SettingR.MyAccount.link({})} />
              ),
              active: path === SettingR.MyAccount.link({}),
            },
            {
              title: "2段階認証設定",
              hidden: false,
              anchor: (props) => (
                <NavLink {...props} to={SettingR.Mfa.link({})} />
              ),
              active: path === SettingR.Mfa.link({}),
            },
          ],
        },
        {
          header: "監査ログ",
          navItems: [
            {
              title: FeatureTitles.AuthAuditLog,
              hidden: !hasPermission({
                requirePermissions: "audit_logs.read",
              }),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.AuthAudit.link({})} />
              ),
              active: path === SettingR.AuthAudit.link({}),
            },
            {
              title: FeatureTitles.UserAuditLog,
              hidden: !hasPermission({
                requirePermissions: "audit_logs.read",
              }),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.UserAudit.link({})} />
              ),
              active: path === SettingR.UserAudit.link({}),
            },
          ],
        },
        {
          header: "決済管理",
          navItems: [
            {
              title: "決済データ",
              hidden:
                !auth.data?.orgUsingFeature.usePayment ||
                !hasPermission({
                  requirePermissions: "payments_rawdata.read",
                }),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.Payments.link({})} />
              ),
              active: path === SettingR.Payments.link({}),
            },
          ],
        },
        {
          header: "インボイス",
          navItems: [
            {
              title: "適格請求書発行事業者",
              hidden:
                !auth.data?.orgUsingFeature.usePayment ||
                !hasPermission({
                  requirePermissions: "invoice_business_issuers.create",
                }),
              anchor: (props) => (
                <NavLink
                  {...props}
                  to={SettingR.QualifiedInvoiceBusinessIssuersIndex.link({})}
                />
              ),
              active:
                path === SettingR.QualifiedInvoiceBusinessIssuersIndex.link({}),
            },
          ],
        },
        {
          header: "認証設定",
          navItems: [
            {
              title: "セッション有効期間",
              hidden: !hasPermission({
                requirePermissions:
                  "tenant_management.org_session_settings.read",
              }),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.OrgSessionSetting.link({})} />
              ),
              active: path === SettingR.OrgSessionSetting.link({}),
            },
            {
              title: "SAML SSO設定",
              hidden:
                !auth.data?.orgUsingFeature.useSamlAuth ||
                !hasPermission({
                  requirePermissions: "org_saml_settings.read",
                }),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.OrgSamlSetting.link({})} />
              ),
              active: path === SettingR.OrgSamlSetting.link({}),
            },
          ],
        },
        {
          header: "サポート",
          navItems: [
            {
              title: "Grafferからのお知らせ",
              hidden: auth.isOnlyUsingEnterpriseProduct(),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.NotifFromGraffer.link({})} />
              ),
              active: path === SettingR.NotifFromGraffer.link({}),
            },
            {
              title: "ヘルプ",
              hidden: auth.isOnlyUsingEnterpriseProduct(),
              anchor: (props) => (
                <NavLink {...props} to={SettingR.GrafferServiceHelp.link({})} />
              ),
              active: path === SettingR.GrafferServiceHelp.link({}),
            },
            {
              title: "マニュアル",
              hidden: auth.isOnlyUsingEnterpriseProduct(),
              anchor: (props) => (
                <NavLink
                  {...props}
                  to={SettingR.GrafferServiceDocument.link({})}
                />
              ),
              active: path === SettingR.GrafferServiceDocument.link({}),
            },
            {
              title: "スマート申請API仕様書",
              hidden: !(
                hasPermission({
                  requirePermissions: "service_account.service_account.read",
                }) &&
                auth.isProductAvailable("SmartApply") &&
                StaticFeatureFlags.ENABLE_SMART_APPLY_EXTERNAL_API_SPEC
              ),
              anchor: (props) => (
                <NavLink
                  {...props}
                  to={SettingR.SmartApplyExternalApiSpec.link({})}
                />
              ),
              active: path === SettingR.SmartApplyExternalApiSpec.link({}),
            },
            {
              title: "ステータスページ",
              hidden: !auth.isOnlyUsingEnterpriseProduct(),
              anchor: () => {
                return (
                  <a
                    href="https://www.grafferstatus.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ステータスページ
                  </a>
                );
              },
            },
          ],
        },
      ]}
    />
  );
};
